import React, { useEffect, useState, useRef } from 'react';
import services from '../services';
import { toast } from 'react-toastify';
import Loading from '../utils/Loading';
import Select from 'react-dropdown-select';
import { Tooltip } from 'react-tooltip';
import EditorComponent from '../components/Template/Editor';

const ComposeEmail = ({ selectedId, setModalOpen }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [compose, setCompose] = useState({
        sentTo: '',
        subject: '',
        body: '',
        parentTaskID: '',
        parentTaskStatus: '',
        sentBy: '',
        boardId: '',
    });

    const [templateselect, setTemplateselect] = useState([]);
    const [allTemp, setAllTemp] = useState([]);
    const [bodyManuallyEdited, setBodyManuallyEdited] = useState(false);
    const [editorKey, setEditorKey] = useState('compose-editor');
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);
    const handleDelete = async () => {
        try {
            await services.draft.DELETE_BY_ID_DRAFT(selectedId);
            toast.success("Delete successfully");
            setModalOpen(false)
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong. Please try again !");
        }
    }

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('sentBy', compose.sentBy);
        formData.append('boardListId', compose.boardListId);
        formData.append('parentTaskID', compose.parentTaskID)
        formData.append('sentTo', compose.sentTo);
        formData.append('body', compose.body);
        formData.append('subject', compose.subject);
        formData.append('boardId', compose.boardId);
        formData.append('bcc', compose.bcc || '');
        formData.append('cc', compose.cc || '');

        uploadedFiles.forEach((file) => {
            formData.append('attachments', file);
        });

        try {
            setIsUploading(true);
            await services.compose.SEND_COMPOSE(formData);
            await services.draft.DELETE_BY_ID_DRAFT(selectedId)
            setModalOpen(false);
            toast.success('Compose Email Sent Successfully...');
        } catch (e) {
            console.error(e);
            toast.error('Failed to send email');
        } finally {
            setIsUploading(false);
        }
    };

    const handleRemoveFile = (index) => {
        setCompose((prev) => ({
            ...prev,
            attachmentPaths: [],
        }));
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const MAX_IMAGES = 10;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (uploadedFiles.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setUploadedFiles((prev) => [...prev, ...newFiles]);
        }
    };

    const getTemplate = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();
            if (response) {
                setAllTemp(
                    response &&
                    response.length > 0 &&
                    response
                        .filter((item) => item.status === true)
                        .map((item) => ({
                            label: item?.name,
                            value: item?.body,
                            displayValue: item?.body.replace(/\n/g, ' '),
                        })),
                );
            }
        } catch (e) {
            console.error(e);
        }
    };


    useEffect(() => {
        getTemplate();
    }, []);

    useEffect(() => {
        if (!templateselect) {
            setCompose(prev => ({ ...prev, body: "" }));
            setBodyManuallyEdited(false);
            return;
        }

        const selected = allTemp.find(option => option.value === templateselect);
        if (selected && !bodyManuallyEdited) {
            let templateBody = selected.value || '';
            setCompose(prev => ({
                ...prev,
                body: templateBody,
            }));
        }
    }, [templateselect, allTemp, bodyManuallyEdited]);
    
    const isValidEmail = (email) => {
        if (!email) return true;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const getDraftEmailbyid = async () => {
        try {
            const res = await services.draft.GET_BY_ID_DRAFT(selectedId)
            const data = res?.data?.data
            setCompose({
                sentTo: data?.sentTo || "",
                subject: data?.subject || "",
                body: data?.body,
                cc: data?.cc || "",
                sentBy: data?.sentBy || "",
                boardId: data?.boardId || "",
                bcc: data?.bcc || "",
                parentTaskID: data?.parentTaskID,
                boardListId: data?.boardListId
            });

        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getDraftEmailbyid();
    }, [selectedId])
    
    return (
        <div
            className={` p-4   text-black shadow-lg`}
        >
            <div className=" overflow-y-auto pr-2">
                <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
                    <input
                        type="text"
                        className="block  px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                        value={compose.sentBy || ''}
                        onChange={(e) =>
                            setCompose((prev) => ({
                                ...prev,
                                sentBy: e.target.value,
                            }))
                        }
                    />
                </div>
                <div className="mb-2">
                    <div className="flex items-center justify-between">
                        <label className="text-sm font-medium text-gray-700">To</label>
                        <div className="flex gap-4 text-sm text-black-600 cursor-pointer">
                            {!showCc && (
                                <span onClick={() => setShowCc(true)} className="hover:underline">
                                    Cc
                                </span>
                            )}
                            {!showBcc && (
                                <span onClick={() => setShowBcc(true)} className="hover:underline">
                                    Bcc
                                </span>
                            )}
                        </div>
                    </div>

                    <input
                        id="recipients"
                        placeholder="To"
                        type="email"
                        className={`block w-full px-3 py-2 rounded-md border ${compose?.sentTo && !isValidEmail(compose.sentTo)
                            ? "border-red-500"
                            : "border-gray-300"
                            } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm`}
                        value={compose?.sentTo}
                        onChange={(e) => {
                            const value = e.target.value;
                            setCompose((prev) => ({ ...prev, sentTo: value }));
                        }}
                    />

                    {compose?.sentTo && !isValidEmail(compose.sentTo) && (
                        <p className="mt-1 text-sm text-red-500">Enter a valid email address</p>
                    )}
                    {showCc && (
                        <div className="mb-2">
                            <label className="text-sm font-medium text-gray-700">Cc</label>
                            <input
                                type="email"
                                placeholder="Cc"
                                className={`block w-full px-3 py-2 mt-1 rounded-md border ${compose?.cc
                                    ? "border-red-500"
                                    : "border-gray-300"
                                    } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm`}
                                value={compose?.cc || ""}
                                onChange={(e) => setCompose((prev) => ({ ...prev, cc: e.target.value }))}
                            />

                        </div>
                    )}
                    {showBcc && (
                        <div className="mb-2">
                            <label className="text-sm font-medium text-gray-700">Bcc</label>
                            <input
                                type="email"
                                placeholder="Bcc"
                                className={`block w-full px-3 py-2 mt-1 rounded-md border ${compose?.bcc
                                    ? "border-red-500"
                                    : "border-gray-300"
                                    } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm`}
                                value={compose?.bcc || ""}
                                onChange={(e) => setCompose((prev) => ({ ...prev, bcc: e.target.value }))}
                            />

                        </div>
                    )}

                </div>


                <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                    <input
                        id="subject"
                        placeholder="Subject"
                        type="text"
                        className="block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                        value={compose?.subject}
                        onChange={(e) => setCompose((prev) => ({ ...prev, subject: e.target.value }))}
                    />
                </div>

                <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                    <EditorComponent
                        className="h-[200px]"
                        key={editorKey}
                        selectedPrevData={{ templateData: compose.body }}
                        handleEditorChange={(data) => setCompose((prev) => ({ ...prev, body: data }))}
                        allTemp={allTemp}
                        textAreaValue={compose?.body}

                    />
                </div>
                {uploadedFiles.length > 0 && (
                    <div className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-md p-3 mb-4">
                        <div className="flex flex-wrap gap-4">
                            {uploadedFiles.map((file, idx) =>
                                file.type.startsWith('image/') ? (
                                    <div className="email-file-preview" key={idx}>
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt={`Preview ${idx}`}
                                            className="rounded-md w-24 h-24 object-cover shadow"
                                        />
                                        <button
                                            onClick={() => handleRemoveFile(idx)}
                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                            title="Remove"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                ) : (
                                    <div key={idx} className="email-file-preview flex items-center gap-2 bg-white rounded px-2 py-1 shadow">
                                        <span>{file.name}</span>
                                        {file.type === 'application/pdf' && <span className="text-xs text-gray-500">(PDF)</span>}
                                        <button
                                            onClick={() => handleRemoveFile(idx)}
                                            className="bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                            title="Remove"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )}


                <div className="flex items-center justify-between w-full mt-4">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={handleSubmit}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full px-8 py-2 shadow-sm flex items-center gap-2 text-[15px] transition"
                        >
                            {isUploading ? 'Sending...' : 'Send'}
                        </button>

                        <label
                            data-tooltip-id="upload-tooltip"
                            data-tooltip-content="Attach files"
                            className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 cursor-pointer"
                        >
                            <input
                                type="file"
                                accept="image/*,application/pdf"
                                multiple
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-paperclip"
                                viewBox="0 0 16 16"
                            >
                                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                            </svg>
                        </label>

                        <Tooltip id="upload-tooltip" place="top" style={{ fontSize: '12px', marginBottom: '5px' }} />
                    </div>

                    <button onClick={handleDelete}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="text-gray-500"
                            viewBox="0 0 16 16"
                        >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7H6v7a.5.5 0 0 1-1 0v-7z" />
                            <path
                                fillRule="evenodd"
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3a.5.5 0 0 0-.5.5V4h12v-.5a.5.5 0 0 0-.5-.5h-11z"
                            />
                        </svg>
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ComposeEmail;
